import { render, staticRenderFns } from "./GenderSelect.vue?vue&type=template&id=35f5c767&scoped=true"
import script from "./GenderSelect.vue?vue&type=script&lang=js"
export * from "./GenderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5c767",
  null
  
)

export default component.exports